import React from 'react';

import { Stack, Typography, SpeedDial, SpeedDialAction, Box } from '@mui/material';
import { ListCard } from 'components/Card';
import { IconWrapper } from 'components/Icon';
import { isoToDateString } from 'utils/dateFormatter';
import { useAuth } from 'lib/auth';

export const SubscribersListItem = ({ id, email, created_on, markForDelete, source }) => {
  const { account } = useAuth();

  return (
    <ListCard
      sx={{
        '& .MuiTypography-body2': {
          fontSize: { md: '0.75rem', lg: '0.875rem' },
        },
        '& .MuiTypography-caption': {
          fontSize: { md: '0.625rem', lg: '0.75rem' },
        },
      }}
    >
      {account.super_admin && (
        <>
          <Stack justifyContent="center" flex={4} px={1}>
            <Typography variant="caption" fontWeight={700}>
              Email
            </Typography>
            <Typography variant="body2" fontWeight={700}>
              {email}
            </Typography>
          </Stack>
          <Stack justifyContent="center" flex={1.5} px={1}>
            <Typography variant="caption" fontWeight={700}>
              Source
            </Typography>
            <Typography variant="body2" fontWeight={700}>
              {source}
            </Typography>
          </Stack>
          <Box flex={1.5} position="relative" sx={{ alignSelf: 'center' }}>
            <Stack justifyContent="center" flex={1} pr={1}>
              <Typography variant="caption" fontWeight={700}>
                Date and time
              </Typography>

              <Typography variant="body2" fontWeight={700}>
                {isoToDateString(created_on, true)}
              </Typography>
            </Stack>
            <SpeedDial
              direction="left"
              ariaLabel="Subscriber actions"
              icon={
                <IconWrapper
                  icon="elipsisVertical"
                  sx={({ palette }) => ({
                    svg: { stroke: palette.grey[500], color: palette.grey[500] },
                  })}
                />
              }
              sx={({ palette }) => ({
                '.MuiSpeedDial-actions': {
                  bgcolor: 'white',
                  borderRadius: 4,
                  pr: 0,
                  mr: 0,
                  border: `1px solid ${palette.grey[200]}`,
                },
                '.MuiSpeedDial-actionsClosed': { bgcolor: 'transparent', border: 'none' },
                '& > button': {
                  boxShadow: 'none',
                  bgcolor: palette.background.paper,
                  width: 36,
                  height: 36,
                },
                '& > button:hover': { bgcolor: palette.background.paper },
                position: 'absolute',
                right: 0,
                top: 'calc(50% - 28px)',
                zIndex: 1,
              })}
            >
              <SpeedDialAction
                onClick={markForDelete}
                sx={({ palette }) => ({
                  bgcolor: palette.grey[50],
                  '&:hover': { bgcolor: palette.grey[200] },
                })}
                icon={
                  <IconWrapper
                    icon="trash"
                    sx={({ palette }) => ({
                      svg: {
                        width: 20,
                        height: 20,
                        stroke: palette.grey[500],
                        color: palette.grey[500],
                      },
                    })}
                  />
                }
                slotProps={{
                  tooltip: {
                    title: "Delete",
                  },
                }}
              />
            </SpeedDial>
          </Box>
        </>
      )}
    </ListCard>
  );
};
